<template>
  <div class="rounded-md h-100p">
    <SimpleWarningDialog
      v-if="showDeleteWarn && checkedItems.length > 0"
      :title="$t('deleteWarn')"
      :text="stateValues.deleteWarningSubText"
      :secondaryBtn="true"
      @onPrimary="onClickCompleteProcess"
      @onSecondary="onClickCancelProcess"
    />
    <SimpleWarningDialog
      v-if="stateValues.showSendLinkWarn"
      :title="$t('sendLinkWarn')"
      :secondaryBtn="true"
      @onPrimary="onClickCompleteSendLink"
      @onSecondary="onClickCancelSendLink"
    />
    <JoiningVideoCallDialog
      v-if="stateValues.showJoiningVideoCallDialog"
      :fullName="stateValues.fullName"
      :meetingId="stateValues.meetingId"
      @onClickCancelJoinVideoCall="onClickCancelJoinVideoCall"
      @onClickAttemptJoinVideoCall="onClickAttemptJoinVideoCall"
    ></JoiningVideoCallDialog>
    <user-card
      v-if="stateValues.showUserCardDialog"
      pageType="ProcessList"
      :leadPartyId="stateValues.leadPartyId"
      :tckn="stateValues.tckn"
      :processId="stateValues.processId"
      :note="stateValues.note"
      @onClickOkCustomerCard="onClickOkCustomerCard"
    />
    <AddNoteDialog
      v-if="stateValues.showAddNoteDialog"
      :processId="stateValues.processId"
      @onClickCloseAddNoteDialog="onClickCloseAddNoteDialog"
    />
    <DropAssigneeDialog
      v-if="stateValues.showDropAssigneeDialog"
      :processId="stateValues.processId"
      :leadPartyId="stateValues.leadPartyId"
      @onClickCloseDropAssigneeDialog="onClickCloseDropAssigneeDialog"
    />
    <div class="title-wrapper">
      <h1 class="title">
        {{ $t("AllAuthAndVideoCall") }}
      </h1>
    </div>

    <div class="content-container">
      <div class="content-wrapper">
        <AllOngoingProcessListTable
          ref="table"
          :showSelect="stateValues.inDeletingMode"
          @onClickCustomerCard="onClickCustomerCard"
          @onClickJoinVideoCall="onClickJoinVideoCall"
          @onClickDropAssignee="onClickDropAssignee"
          @onClickAddNote="onClickAddNote"
          @onClickSendLink="onClickSendLink"
          @onCheckedItems="setCheckedItems"
        />
      </div>
    </div>
    <div class="buttons-wrapper">
      <v-btn
        v-if="
          stateValues.modeOfDeletion == 'process' || !stateValues.inDeletingMode
        "
        class="mr-4"
        color="black"
        @click="toggleWarnButtons('process')"
      >
        <v-icon class="mr-2" color="white">{{
          stateValues.inDeletingMode ? "mdi-cancel" : "mdi-trash-can-outline"
        }}</v-icon>
        <span class="color--primary--white">{{
          $t(stateValues.inDeletingMode ? "cancel" : "deleteProcesses")
        }}</span>
      </v-btn>
      <v-btn
        v-if="stateValues.inDeletingMode"
        class="mr-4"
        color="primary"
        @click="onClickDeleteButton"
        :loading="deleteLoading"
        :disabled="
          deleteLoading ||
          (stateValues.modeOfDeletion == 'process' &&
            checkedItems.length != 1) ||
          (stateValues.modeOfDeletion == 'lead' && checkedItems.length == 0)
        "
      >
        <v-icon class="mr-2">mdi-check-circle-outline</v-icon>
        {{ $t("complete") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import AllAuthAndVideoCall from "./mixin/AllAuthAndVideoCall";
import { AllAuthAndVideoCallComponents } from "../../components";

export default {
  mixins: [AllAuthAndVideoCall],
  components: { ...AllAuthAndVideoCallComponents }
};
</script>

<style lang="scss" scoped>
$primaryColor: #0032a0;

.h-100p {
  height: 100%;
}

.header-table-divider {
  margin-top: 2%;
}
.btn-new-identity {
  background-color: $primaryColor !important;
  color: white;
}
.v-btn {
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/authandvideocall/AllAuthAndVideoCall.vue